export default __webpack_public_path__ + "static/media/Charging.8ae3d0e8.svg";